import { render, staticRenderFns } from "./TagSpecialCoin.vue?vue&type=template&id=2e344927&scoped=true&"
import script from "./TagSpecialCoin.vue?vue&type=script&lang=ts&"
export * from "./TagSpecialCoin.vue?vue&type=script&lang=ts&"
import style0 from "./TagSpecialCoin.vue?vue&type=style&index=0&id=2e344927&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e344927",
  null
  
)

export default component.exports